<template>
  <div :class="rootClass">
    <b-row>
      <b-col cols="12">
        <b-row class="mb-2">
          <b-col lg="3" sm="12">
            <b-row align-v="center">
              <label :class="rootClass + '__phone-number-label'">Số thuê bao</label>
              <b-form-input
                  ref="inputSearchPhone"
                  v-model="searchPhone"
                  :class="rootClass + '__phone-number-input'"
                  v-on:keyup.enter="getPackageDetail"
              ></b-form-input>
            </b-row>
          </b-col>
          <b-col lg="2" sm="12" style="display: flex; align-items: center">
            <b-button
                :class="rootClass + '__search-btn'"
                class="redButton"
                variant="danger"
                @click="getPackageDetail"
            >Tra cứu
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <table :class="rootClass + '__history-table'">
            <tr style="height: 3rem;position: sticky">
              <template v-for="(h, i) in tableFields">
                <th
                    :key="h.key"
                    :class="{
                      '--first-th': i === 0,
                      '--last-th': i === tableFields.length - 1,
                    }"
                    style="min-width: 120px"
                >
                  {{ h.label }}
                </th>
              </template>
            </tr>
            <template v-for="(r,index) in packageDetailData" v-if="showErrSearch===false">
              <tr :key="index" style="color:black;">
                <td>{{ r.TenGoiCuoc }}</td>
                <td>{{ r.NgayBatDau }}</td>
                <td>{{ r.NgayKetThuc }}</td>
                <td>{{ r.DataMain }}</td>
                <td>{{ r.dataSub }}</td>
                <td>{{ r.dataKm }}</td>
                <td>{{ r.dataInZone }}</td>
                <td>{{ r.dataOutZone }}</td>
                <td>{{ r.voiceOnNet }}</td>
                <td>{{ r.voiceOutNet }}</td>
                <td>{{ r.smsOnNet }}</td>
                <td>{{ r.smsOutNet }}</td>
                <td>{{ r.VoiceNational }}</td>
                <td>{{ r.Smscontent }}</td>
                <td>{{ r.PakageName }}</td>
              </tr>
            </template>
          </table>
        </b-row>
        <b-row v-if="showErrSearch" style="justify-content: center;font-size: 18px">
          Không tìm thấy kết quả!
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BFormInput,
  BRow,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BButton,
  },
  data() {
    return {
      rootClass: "package-detail",
      searchPhone: "",
      regex087: /87\d{7}$/,
      showErrSearch: false,
      packageDetailData: [],
      tableFields: [
        {key: "tenGoiCuoc", label: "Tên gói cước"},
        {key: "ngayBatDau", label: "Ngày bắt đầu"},
        {key: "ngayKetThuc", label: "Ngày kết thúc"},
        {key: "dataMain", label: "DataMain"},
        {key: "dataSub", label: "dataSub"},
        {key: "dataKm", label: "dataKm"},
        {key: "dataInZone", label: "dataInZone"},
        {key: "dataOutZone", label: "dataOutZone"},
        {key: "voiceOnNet", label: "voiceOnNet"},
        {key: "voiceOutNet", label: "voiceOutNet"},
        {key: "smsOnNet", label: "smsOnNet"},
        {key: "smsOutNet", label: "smsOutNet"},
        {key: "voiceNational", label: "VoiceNational"},
        {key: "smscontent", label: "Smscontent"},
        {key: "pakageName", label: "PakageName"},
      ]
    };
  },
  props: {
    searchPhone: String
  },
  mounted() {
    if (this.searchPhone) {
      this.getPackageDetail();
    }
  },
  methods: {
    formatPhoneNum() {
      if (this.searchPhone.startsWith("0")) {
        this.searchPhone = this.searchPhone.substring(1);
        this.searchPhone = 84 + this.searchPhone;
      }
    },
    getPackageDetail() {
      this.showLoading("block")
      this.formatPhoneNum();
      if (this.regex087.test(this.searchPhone)) {
        useJwt.get('get-current-package-detail/' + this.searchPhone).then((response) => {
          this.showLoading("none")
          if (response.data.code === 200) {
            this.packageDetailData = response.data.result;
            this.showErrSearch = this.packageDetailData.length === 0;
          } else {
            this.showErrSearch = true;
            this.$toast.error(response.data.message, {
              position: "top-right",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false
            });
          }
          console.log("getPackageDetail", response.data);
        }).catch((error) => {
          this.showLoading("none")
          this.showErrSearch = true;
          console.log(error);
        });
      } else {
        this.showLoading("none")
        this.$refs.inputSearchPhone.focus()
        if (this.searchPhone === "") {
          this.$toast.error("Vui lòng nhập số thuê bao", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        } else {
          this.$toast.error("Số thuê bao chưa hợp lệ", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        }
      }
    },
    showLoading(options) {
      document.getElementById('loading-bg').style.display = options;
    },
  }
};
</script>

<style lang="scss" scoped>
.package-detail {
  position: relative;
  font-size: 16px;
  font-family: "Times New Roman";
  min-height: 500px;

  &__phone-number-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 80px;
  }

  &__phone-number-input {
    font-weight: 500;
    color: black;
    font-size: 14px;
    width: 200px;
  }

  &__search-btn {
    border-radius: 40px;
  }

  &__history-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;
    overflow-x: auto;

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border: 0.299185px solid rgba(184, 184, 184, 0.5);
    }

    th {
      background-color: #ED1F24;
      color: white;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }
}

.redButton {
  background-color: #ED1F24 !important;
  border-color: #ED1F24 !important;
}

@media screen and (max-width: 576px) {
  .package-detail {
    &__phone-number-label {
      width: 100%;
    }

    &__phone-number-input {
      width: 100%;
    }
  }
}
</style>
